import { Flatfile } from "@flatfile/api";
import { membersTableConfig } from "./membersTableConfig";

export const workbookConfig: Flatfile.CreateWorkbookConfig = {
  actions: [
    {
      operation: "submitActionFg",
      mode: "foreground",
      label: "Save and close",
      type: "string",
      primary: true,
      confirm: false,
      icon: "arrowUpRight",
      constraints: [{ type: "hasAllValid" }],
    },
  ],
  name: "Add or edit members",
  labels: ["pinned"],
  namespace: "migratingUsers",
  sheets: [membersTableConfig],
};
